module.exports = __webpack_public_path__ + "static/media/hand-hygiene.275705ff.png";